const main = () => {
  const form = document.querySelector(
    'form[action="/book/confirmation"][method="POST"]'
  )

  if (form === null) {
    return
  }

  setupApplyPromoCodeButton(form)
  setupRemovePromoCodeButton(form)
}

const setupApplyPromoCodeButton = form => {
  const button = form.querySelector(
    'button[type="submit"][id="apply-promo-code"]'
  )

  if (button === null) {
    return
  }

  button.addEventListener('click', event => {
    event.preventDefault()

    form.setAttribute('action', '/book/cart/promo-code')
    form.submit()
  })
}

const setupRemovePromoCodeButton = form => {
  const button = form.querySelector(
    'button[type="submit"][id="remove-promo-code"]'
  )

  if (button === null) {
    return
  }

  button.addEventListener('click', event => {
    event.preventDefault()

    form.setAttribute('action', '/book/cart/promo-code')
    form.submit()
  })
}

main()



// WEBPACK FOOTER //
// ./src/js/_promo-code.js